import { AllEvents, PublicationCardItem } from '@news-mono/web-common'
import * as React from 'react'

export interface DevelopingNewsProps {
    headLine: string
    item: PublicationCardItem[]
    onEvent: (event: AllEvents) => void
}

export const DevelopingNews: React.FC<DevelopingNewsProps> = ({
    headLine,
    item,
    onEvent,
}) => {
    return <></>
}
